import * as React from "react";

import { getRoutePath, redirectToRoutePath, sectionClasses } from "../common/Utils";
import { QuoteFormEventType } from "../../../Common/QuoteFormEventTracking/QuoteFormEventType";
import { WizardStep } from "../common/WizardStep";

import { IStepProps } from "../interfaces/IStepProps";
import { IStepState } from "../interfaces/IStepState";
import { IAutoWizardModel } from "../interfaces/IAutoWizardModel";

import { LogStep } from "../../../Common/QuoteFormEventTracking/LogStep";

interface IVehicleMakeStepProps extends IStepProps {
    vehicleMakes: string[];
    setVehicleModels(vehicleModels: string[]): void;
};

declare var awl: any;

export class VehicleMakeStep extends React.Component<IVehicleMakeStepProps, IStepState> {

    state: IStepState;

    constructor(props: IVehicleMakeStepProps) {
        super(props);

        this.handleOnClickVehicleMake = this.handleOnClickVehicleMake.bind(this);
        this.handleOnChangeSelectVehicleMake = this.handleOnChangeSelectVehicleMake.bind(this);
        this.handleSuccessfulRequest = this.handleSuccessfulRequest.bind(this);

        this.state = {
            redirectPath: "",
            goToNextStep: false
        }
    }

    nextStep(vehicleMake: string): void {
        
        var request = new XMLHttpRequest();
        var yearArgument: string = "&year=" + this.props.model.primaryVehicle.year;
        var makeArgument: string = "&make=" + vehicleMake;

        if (!awl.autoWizard.ajaxVehicleModelsUrl.includes("?")) {
            yearArgument = "?year=" + this.props.model.primaryVehicle.year;
            var makeArgument: string = "&make=" + vehicleMake;
        }

        const handleSuccessfulRequest = this.handleSuccessfulRequest;

        request.open('GET', awl.autoWizard.ajaxVehicleModelsUrl + yearArgument + makeArgument, true);

        request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

        request.withCredentials = true;

        request.onreadystatechange = function() {
            if (this.readyState === 4) {
                if (this.status >= 200 && this.status < 400) {
                    // Success!
                    let data: string[] = JSON.parse(this.responseText);

                    handleSuccessfulRequest(vehicleMake, data);

                } else {
                    // Error :(
                }
            }
        };

        request.send();
        request = null;
    }

    handleSuccessfulRequest(vehicleMake: string, data: string[]): void {
        this.props.setVehicleModels(data);

        let model: IAutoWizardModel = JSON.parse(JSON.stringify(this.props.model));

        model.primaryVehicle.make = vehicleMake;

        this.props.onUpdateModel(model);

        const routePath = getRoutePath(WizardStep.PRIMARY_VEHICLE_MODEL);

        this.setState({ redirectPath: routePath, goToNextStep: true });
    }

    handleOnClickVehicleMake(event: React.MouseEvent<HTMLAnchorElement>): void {
        let valueElement = event.target as HTMLAnchorElement;
        let value = valueElement.dataset["value"];

        this.clearVehicleMakeSelect();
        this.nextStep(value);
    }

    handleOnChangeSelectVehicleMake(event: React.FormEvent<HTMLSelectElement>): void {
        let valueElement = event.target as HTMLSelectElement;
        let value = valueElement.value;

        this.nextStep(value);
    }
    
    clearVehicleMakeSelect(): void {
        let valueElement = document.getElementById("vehicleMakeSelection")as HTMLSelectElement;
        valueElement.value = "";
    }

    render(): JSX.Element {
        if (this.state.goToNextStep) {
            redirectToRoutePath(this.state.redirectPath);
            return null;
        }

        const hiddenErrorStyle = { display: 'none' };

        let vehicleMakesTouchOptions: any[] = [];
        let vehicleMakesSelectOptions: any[] = [];
        let primaryMakes: string[] = ['CHEVROLET', 'FORD', 'TOYOTA', 'DODGE', 'NISSAN', 'HONDA', 'HYUNDAI', 'CHRYSLER'];
        let vehicleMakes = this.props.vehicleMakes.slice(0);

        for(var i = 0; i<primaryMakes.length; i++) {
            let vehicleTouchOptionId = "vehicleMake_" + primaryMakes[i];
            let touchOptionClasses = "touch-list-option";
            let linkOptionClasses = this.props.model.primaryVehicle.make &&
                this.props.model.primaryVehicle.make === primaryMakes[i]
                ? " selected"
                : "";

            vehicleMakesTouchOptions.push(<div key={vehicleTouchOptionId} className={touchOptionClasses}><a className={linkOptionClasses} data-value={primaryMakes[i]} id={vehicleTouchOptionId} onClick={this.handleOnClickVehicleMake}>{primaryMakes[i]}</a></div>)
            vehicleMakes.splice(vehicleMakes.indexOf(primaryMakes[i]), 1);
        }

        for (var j = 0; j < vehicleMakes.length; j++) {
            let vehicleMakesOptionKey = "vehicleMake_" + vehicleMakes[j];
            vehicleMakesSelectOptions.push(<option key={vehicleMakesOptionKey} value={vehicleMakes[j]}>{vehicleMakes[j]}</option>);
        }

        const sectionStyle = {
            display: 'block'
        }

        return <React.Fragment>
            <LogStep lastStep="VehicleYear" nextStep="VehicleModel" stepNumber={QuoteFormEventType.VehicleMakeStep} sectionName="VehicleName" wizardName="AutoWizard" logStep={true}/>
            <div id="VehicleMakeStep" className={sectionClasses} style={sectionStyle}>
                   <h3>Select Your Vehicle Make:</h3>
                   <div id="VehicleMake">
                       <div className="touch-list twoColumn" >
                           {vehicleMakesTouchOptions}
                </div>
                <select className="dropdown-list" id="vehicleMakeSelection" onChange={this.handleOnChangeSelectVehicleMake}>
                           <option value="">Select another make</option>
                           {vehicleMakesSelectOptions}
                       </select>
                   </div>
            </div>
            </React.Fragment>;

    }
};